import React from 'react';
import PropTypes from 'prop-types';
import type { CardProps } from './Card.types';
import './card.scss';

const Card = ({ children, elevated, hover }: CardProps) => {
  const isElevated = elevated ? 'sb-card--elevated' : '';
  const hasHover = hover ? 'sb-card--hover' : '';

  return (
    <div
      className={['sb-card',
        isElevated,
        hasHover].join(' ')}
      data-testid="sb-card"
    >
      {children}
    </div>
  );
};

Card.propTypes = {
  /**
* children
*/
  children: PropTypes.object,
  /**
* hover
*/
  hover: PropTypes.bool,
  /**
* elevated
*/
  elevated: PropTypes.bool,
};

Card.defaultProps = {
  children: <div></div>,
  elevated: false,
  hover: false,
};

export default Card;